import assert from "assert";
import { String } from "runtypes";
import { CourseName } from "./course";
import { nextSemesterFromCurrent, previousSemesterFromCurrent, semesterFromShorthand } from "./semesters";
export const SEMESTER = String.check(process.env.SEMESTER ?? process.env.NEXT_PUBLIC_SEMESTER);
export const currentSemester = semesterFromShorthand(SEMESTER);
assert(currentSemester);
export const previousSemester = previousSemesterFromCurrent(currentSemester);
assert(previousSemester);
export const nextSemester = nextSemesterFromCurrent(currentSemester);
assert(nextSemester);
export const currentCourse = CourseName.check({
  department: "CS",
  number: "124",
  semester: currentSemester.name,
  year: currentSemester.year
});
//# sourceMappingURL=current.js.map
